import { gql } from '@apollo/client'

export default gql`
  mutation course_chapters_delete($id: ID!) {
    courseChapterDelete(id: $id) {
      id
    }
  }
`
